import { render, staticRenderFns } from "./tloanapply.vue?vue&type=template&id=afeed5f4&scoped=true&"
import script from "./tloanapply.vue?vue&type=script&lang=js&"
export * from "./tloanapply.vue?vue&type=script&lang=js&"
import style0 from "./tloanapply.vue?vue&type=style&index=0&id=afeed5f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afeed5f4",
  null
  
)

export default component.exports